import axiosInstance from '../configs/axios/interceptors';
import { handleDateConvertForApis } from '../utils/functions';

const FgasDocumentsServices = {

    getFgasDocuments: async (filters) => {
        const response = await axiosInstance.get('Document_FGAS/GetDocument_FGASList', { params: filters });
        return response.data;
    },

    addDocument: async (payload) => {
        const response = await axiosInstance.post('Document_FGAS/AddDocument_FGAS', payload, { params: payload });
        return response.data;
    },

    updateDocument: async (payload) => {
        const response = await axiosInstance.put('Document_FGAS/UpdateDocument_FGAS', payload);
        return response.data;
    },

    removeDocumentAtachment: async (attachmentId, userId) => {
        const params = { attachmentID: attachmentId, userID: userId };
        const response = await axiosInstance.delete('Attachment_FGAS/DeleteAttachment_FGAS', { params: params });
        return response.data;
    },

    getFgasDocumentDetails: async (documentId, userId) => {
        const params = { documentId, userId };
        const response = await axiosInstance.get('Document_FGAS/GetDocument_FGASDetails', { params: params });
        return response.data;
    },

    deleteDocument: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.delete('Document_FGAS/RemoveDocument_FGAS', { params: params });
        return response.data;
    },


    readDocumentPDF: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.get('Attachment_FGAS/ReadPDF_FGAS', { params: params });
        return response.data;
    },

    addDocumentAttachment: async (payload) => {
        const response = await axiosInstance.post('Attachment_FGAS/UploadFile_FGAS', payload);
        return response.data;
    },

    getDocumentAttachments: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.get('Attachment_FGAS/GetAttachments_FGAS', { params: params });
        return response.data;
    },

    getDocumentNotes: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.get('Document_FGAS/GetDocumentNotes_FGAS', { params: params });
        return response.data;
    },

    addDocumentNote: async (payload) => {
        const params = { "documentID": payload.documentID, "note": payload.note, "userID": payload.userID };
        const response = await axiosInstance.post('Document_FGAS/AddDocumentNote_FGAS', payload, { params: params });
        return response.data;
    },

    getSelectedDocumentsList: async (payload) => {
        const bodyData = {
            ...payload,
            dateAddedFrom: payload.dateAddedFrom
                ? handleDateConvertForApis(payload.dateAddedFrom)
                : undefined,
            dateAddedTo: payload.dateAddedTo
                ? handleDateConvertForApis(payload.dateAddedTo)
                : undefined,
            lastUpdatedDateFrom: payload.lastUpdatedDateFrom
                ? handleDateConvertForApis(payload.lastUpdatedDateFrom)
                : undefined,
            lastUpdatedDateTo: payload.lastUpdatedDateTo
                ? handleDateConvertForApis(payload.lastUpdatedDateTo)
                : undefined,
        };

        const cleanBody = Object.fromEntries(
            Object.entries(bodyData).filter(([_, v]) => v != null)
        );

        const response = await axiosInstance.post('Document_FGAS/GetDocuments_FGASListExport', cleanBody);
        return response.data;
    },

    getDocumentListAttachments: async (payload) => {
        const bodyData = {
            ...payload,
            dateAddedFrom: payload.dateAddedFrom
                ? handleDateConvertForApis(payload.dateAddedFrom)
                : undefined,
            dateAddedTo: payload.dateAddedTo
                ? handleDateConvertForApis(payload.dateAddedTo)
                : undefined,
            lastUpdatedDateFrom: payload.lastUpdatedDateFrom
                ? handleDateConvertForApis(payload.lastUpdatedDateFrom)
                : undefined,
            lastUpdatedDateTo: payload.lastUpdatedDateTo
                ? handleDateConvertForApis(payload.lastUpdatedDateTo)
                : undefined,
        };

        const cleanBody = Object.fromEntries(
            Object.entries(bodyData).filter(([_, v]) => v != null)
        );

        const response = await axiosInstance.post('Attachment_FGAS/GetDocument_FGASListAttachments', cleanBody);
        return response.data;
    },

    registerDocument: async (payload) => {
        const params = {
            documentID: payload.documentID,
            userID: payload.userID,
            anomalyID: payload.anomalyID
        };
        const response = await axiosInstance.put('Document_FGAS/RegisterDocument_FGAS', payload, { params: params });
        return response.data;
    },

    documentInSospeso: async (payload) => {
        const params = {
            documentID: payload.documentID,
            userID: payload.userID,
            anomalyID: payload.anomalyID
        };
        const response = await axiosInstance.put('Document_FGAS/DocumentInSospeso_FGAS', params, { params: params });
        return response.data;
    },

    removeDocumentNote: async (noteId) => {
        const params = { documentNoteID: noteId };
        const response = await axiosInstance.delete('Document_FGAS/RemoveDocumentNote_FGAS', { params: params });
        return response.data;
    },

    handelNonCompetenzaFgas: async (payload) => {
        const params = {
            documentID: payload.documentID,
            userID: payload.userID,
        };
        const response = await axiosInstance.put('Document_FGAS/DocumentoNonDiCompetenza_FGAS', payload, { params: params });
        return response.data;
    }

};

export default FgasDocumentsServices;